import { Injectable } from '@angular/core';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AppConfig } from '../../app.config';
import { getBrowserHostname, isProductionHost } from './runtime-mode.service';

export interface Config {
  apiUrl: string;
  clientUrl: string;
  aiKey: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  sytemConfiguration!: Config;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.loadConfigurations();
  }

  private loadConfigurations(): any {
    let currentConfig: Config;

    const hostname = this.getCurrentHostname();

    if (!hostname || isProductionHost(hostname)) {
      currentConfig = AppConfig.Production;
    } else {
      switch (hostname) {
      case this.getHostName(AppConfig.Uat.clientUrl):
        currentConfig = AppConfig.Uat;
        break;
      case this.getHostName(AppConfig.Qa.clientUrl):
        currentConfig = AppConfig.Qa;
        break;
      case this.getHostName(AppConfig.Development.clientUrl):
        currentConfig = AppConfig.Development;
        break;
      default:
        currentConfig = AppConfig.Local;
      }
    }

    this.sytemConfiguration = currentConfig;

    return currentConfig;
  }

  private getCurrentHostname(): string {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }

    return getBrowserHostname();
  }

  private getHostName(url: string): string {
    return url.replace('https://', '').replace('/', '');
  }
}
